// Angular
import { AbstractControl, ValidationErrors } from '@angular/forms';

export class TermsOfServiceValidator {
  static isValid(control: AbstractControl): ValidationErrors | null {
    return control.value ? null : { termsOfServiceRequired: true };
  }
}
